var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 863,
    height: 197,
    viewBox: "0 0 863 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_7517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.476 123.278L311.751 188.385V89.185C311.751 85.8648 313.07 82.6805 315.418 80.3327C317.765 77.985 320.95 76.666 324.27 76.666H373.351C374.407 76.6661 375.448 76.9151 376.389 77.3927C377.331 77.8703 378.146 78.5632 378.77 79.415L393.725 99.838L377.476 123.278Z",
    fill: "#455DEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.527 13.041H380.999C377.133 13.041 373.999 16.175 373.999 20.041V76.845C373.999 80.711 377.133 83.845 380.999 83.845H417.527C421.393 83.845 424.527 80.711 424.527 76.845V20.041C424.527 16.175 421.393 13.041 417.527 13.041Z",
    fill: "white",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.756 25.0479H407.205",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.218 27.9229H403.745",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.535 36.9648H384.019",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.525 36.9648H412.821",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.525 39.665H412.821",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.525 42.3652H400.173",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.82 49.6611H384.304",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.809 49.6611H413.105",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.809 52.3613H409.149",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.809 55.0615H400.457",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.104 62.0977H384.588",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.094 62.0977H413.39",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.094 64.7979H409.434",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.094 67.498H400.742",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.262 31.0352H357.735C352.764 31.0352 348.735 35.0646 348.735 40.0352V92.8392C348.735 97.8097 352.764 101.839 357.735 101.839H390.262C395.233 101.839 399.262 97.8097 399.262 92.8392V40.0352C399.262 35.0646 395.233 31.0352 390.262 31.0352Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.492 43.042H381.941",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.954 45.917H378.481",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.271 54.959H358.755",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.261 54.959H387.557",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.261 57.6592H387.557",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.261 60.3594H374.909",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.556 67.6553H359.04",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.545 67.6553H387.841",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.545 70.3555H383.885",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.545 73.0557H375.193",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.84 80.0918H359.324",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.83 80.0918H388.126",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.83 82.792H384.17",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.83 85.4922H375.478",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.625 195.522H323.717C317.191 195.522 310.675 189.575 311.901 183.705L327.852 100.776C329.284 92.969 333.142 88.959 339.668 88.959H378.129C379.217 88.959 380.286 88.6827 381.238 88.156C382.189 87.6294 382.991 86.8696 383.569 85.948L387.5 79.678C388.077 78.7562 388.879 77.9962 389.831 77.4693C390.782 76.9425 391.852 76.6661 392.94 76.666H480.576C482.128 76.6658 483.665 76.9712 485.099 77.565C486.533 78.1587 487.836 79.0291 488.933 80.1264C490.031 81.2238 490.901 82.5266 491.495 83.9604C492.089 85.3942 492.395 86.931 492.395 88.483L476.444 183.706C475.463 190.193 471.152 195.522 464.625 195.522Z",
    fill: "white",
    stroke: "#8D949D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M440.239 132.368H439.294C439.33 131.833 439.374 131.302 439.374 130.756C439.374 124.407 436.851 118.318 432.362 113.828C427.872 109.338 421.782 106.816 415.433 106.815C410.601 106.818 405.882 108.283 401.899 111.018C397.915 113.753 394.853 117.631 393.115 122.139C390.911 119.954 387.932 118.729 384.828 118.731C381.699 118.733 378.7 119.977 376.488 122.19C374.276 124.402 373.034 127.403 373.034 130.531C373.037 131.212 373.1 131.891 373.221 132.561C369.602 133.106 366.299 134.93 363.911 137.703C361.523 140.476 360.208 144.013 360.206 147.672C360.206 151.73 361.818 155.622 364.687 158.491C367.557 161.36 371.448 162.972 375.506 162.972H440.239C444.297 162.972 448.188 161.36 451.058 158.491C453.927 155.622 455.539 151.73 455.539 147.672C455.539 145.663 455.144 143.673 454.375 141.816C453.607 139.959 452.48 138.272 451.059 136.851C449.638 135.43 447.952 134.303 446.095 133.533C444.238 132.764 442.249 132.368 440.239 132.368V132.368Z",
    fill: "#D4D8E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.856 172.355V138.537",
    stroke: "#7C838B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.752 149.559L404.858 138.538L414.964 149.559",
    stroke: "#7C838B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.27 159.775H436.838C438.824 159.775 440.791 159.384 442.626 158.624C444.46 157.864 446.128 156.75 447.532 155.346C448.937 153.942 450.051 152.275 450.811 150.44C451.571 148.605 451.962 146.638 451.962 144.652V144.652C451.961 140.641 450.368 136.795 447.531 133.96C444.695 131.124 440.849 129.531 436.838 129.531H435.905C435.941 129.003 435.984 128.477 435.984 127.941C435.984 121.667 433.491 115.649 429.054 111.213C424.618 106.776 418.6 104.283 412.326 104.283C407.551 104.285 402.888 105.733 398.952 108.436C395.015 111.139 391.989 114.97 390.271 119.425C388.093 117.265 385.149 116.055 382.082 116.057C378.991 116.057 376.026 117.285 373.84 119.471C371.654 121.657 370.426 124.621 370.426 127.712C370.43 128.385 370.491 129.057 370.611 129.719C367.035 130.258 363.771 132.061 361.411 134.801C359.051 137.541 357.752 141.036 357.75 144.652C357.75 148.663 359.343 152.509 362.179 155.345C365.014 158.181 368.861 159.775 372.871 159.775H390.442",
    stroke: "#7C838B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.232 71.1611H821.853C821.944 69.8151 822.053 68.4761 822.053 67.1031C822.052 51.1174 815.702 35.7867 804.398 24.4831C793.095 13.1796 777.764 6.82892 761.778 6.82812C749.612 6.83372 737.733 10.5222 727.703 17.4083C717.674 24.2944 709.964 34.0554 705.588 45.4071C700.039 39.9041 692.539 36.8197 684.724 36.8271C676.848 36.8287 669.295 39.9585 663.727 45.5282C658.158 51.0978 655.03 58.6512 655.03 66.5271C655.039 68.2416 655.197 69.952 655.502 71.6391C646.392 73.011 638.076 77.6043 632.063 84.5851C626.051 91.5658 622.741 100.471 622.735 109.684C622.735 119.902 626.793 129.701 634.017 136.927C641.242 144.153 651.04 148.213 661.258 148.214H824.23C829.29 148.214 834.3 147.218 838.975 145.281C843.65 143.345 847.898 140.507 851.476 136.929C855.054 133.351 857.892 129.104 859.828 124.429C861.764 119.754 862.761 114.744 862.761 109.684C862.76 99.4666 858.7 89.6682 851.474 82.4439C844.249 75.2196 834.45 71.1611 824.232 71.1611Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.088 163.84H82.163C82.198 163.317 82.241 162.796 82.241 162.262C82.2407 156.047 79.7717 150.087 75.377 145.692C70.9824 141.297 65.022 138.828 58.807 138.828C54.0769 138.83 49.4583 140.264 45.5589 142.942C41.6595 145.619 38.6621 149.415 36.961 153.828C34.8039 151.688 31.8875 150.489 28.849 150.492C27.3328 150.492 25.8314 150.791 24.4306 151.371C23.0298 151.952 21.7571 152.802 20.685 153.875C19.613 154.947 18.7626 156.22 18.1825 157.621C17.6024 159.021 17.3039 160.523 17.304 162.039C17.3074 162.706 17.3686 163.37 17.487 164.026C13.9451 164.559 10.7118 166.345 8.37433 169.059C6.03686 171.773 4.7502 175.235 4.74799 178.817C4.74878 182.789 6.32727 186.598 9.13629 189.407C11.9453 192.215 15.7548 193.793 19.727 193.793H83.088C87.0609 193.793 90.8712 192.215 93.6805 189.406C96.4897 186.596 98.068 182.786 98.068 178.813C98.0664 174.841 96.4874 171.033 93.6783 168.225C90.8691 165.417 87.0598 163.84 83.088 163.84V163.84Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.446 63.874H812.111C812.2 62.553 812.311 61.24 812.311 59.892C812.31 44.2068 806.079 29.1643 794.988 18.0732C783.897 6.98206 768.854 0.750796 753.169 0.75C741.232 0.755534 729.576 4.37472 719.735 11.1314C709.894 17.8881 702.329 27.4657 698.035 38.604C692.59 33.2036 685.229 30.1769 677.56 30.185C669.832 30.1861 662.421 33.2569 656.957 38.722C651.493 44.1872 648.424 51.5989 648.424 59.327C648.433 61.0092 648.588 62.6875 648.887 64.343C639.948 65.6887 631.788 70.1955 625.888 77.0452C619.989 83.8949 616.742 92.6331 616.736 101.673C616.735 106.637 617.712 111.553 619.612 116.14C621.511 120.727 624.295 124.895 627.805 128.406C631.315 131.916 635.483 134.701 640.069 136.601C644.656 138.501 649.572 139.479 654.536 139.479H814.445C824.472 139.479 834.088 135.496 841.178 128.406C848.268 121.316 852.251 111.7 852.251 101.673C852.251 96.7087 851.273 91.793 849.373 87.2067C847.473 82.6204 844.688 78.4533 841.178 74.9432C837.667 71.4332 833.499 68.6491 828.913 66.7498C824.326 64.8505 819.41 63.8733 814.446 63.874V63.874Z",
    stroke: "#D4D8E3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.231 161.149H75.34C75.374 160.649 75.415 160.143 75.415 159.629C75.4147 153.641 73.0358 147.898 68.8015 143.663C64.5672 139.429 58.8242 137.05 52.836 137.05C48.2786 137.052 43.8286 138.434 40.0715 141.013C36.3144 143.593 33.4262 147.249 31.787 151.502C29.7083 149.44 26.8986 148.285 23.971 148.288C22.5101 148.288 21.0634 148.576 19.7137 149.135C18.364 149.694 17.1377 150.514 16.1047 151.547C15.0718 152.58 14.2524 153.807 13.6935 155.156C13.1345 156.506 12.8469 157.953 12.847 159.414C12.8505 160.056 12.9097 160.697 13.024 161.329C9.61113 161.843 6.4957 163.563 4.24338 166.178C1.99106 168.793 0.751217 172.129 0.748993 175.581C0.748993 179.409 2.26949 183.079 4.97598 185.786C7.68248 188.493 11.3533 190.014 15.181 190.014H76.231C80.0591 190.014 83.7305 188.493 86.4374 185.786C89.1443 183.079 90.665 179.408 90.665 175.58C90.6645 171.752 89.1435 168.081 86.4366 165.375C83.7297 162.669 80.0587 161.149 76.231 161.149V161.149Z",
    stroke: "#D4D8E3",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_7517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 862.763,
    height: 196.021,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIllustration);
export default __webpack_public_path__ + "static/media/upload_illustration.a41594720a50b92179feb567d7d39a1f.svg";
export { ForwardRef as ReactComponent };